export default "__VITE_ASSET__ClGMhbdW__"